'use client';

import { Box, Grid, Typography, Stack } from '@mui/material';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

export default function BoardSection() {
    const t = useTranslations('AboutPage.board_section');

    return (
        <Box component="section" sx={{ py: 6 }}>
            <Box sx={{ maxWidth: 'lg', mx: 'auto' }}>
                <Stack spacing={4}>

                    {/* CEO Wataru */}
                    <Grid container columnSpacing={{ xs: 0, md: 8 }} rowSpacing={4} alignItems="center">
                        <Grid size={{ xs: 12, md: 5 }}>
                            <Box sx={{
                                position: 'relative',
                                width: '100%',
                                aspectRatio: '1/1',
                                overflow: 'hidden',
                                borderRadius: 2
                            }}>
                                <Image
                                    src="/images/board-2.jpg"
                                    alt={t('ceo_alt')}
                                    fill
                                    style={{ objectFit: 'cover' }}
                                />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Typography variant="h5" component="h3" sx={{ fontWeight: 800, color: '#132c4b', mb: 4 }}>
                                {t('ceo_name')}
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1e293b', mb: 3, lineHeight: 1.8 }}>
                                {t('ceo_bio_1')}
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1e293b', lineHeight: 1.8 }}>
                                {t('ceo_bio_2')}
                            </Typography>
                        </Grid>
                    </Grid>

                    {/* CTO Va Kora */}
                    <Grid container columnSpacing={{ xs: 0, md: 8 }} rowSpacing={4} alignItems="center" direction={{ xs: 'column-reverse', md: 'row' }}>
                        <Grid size={{ xs: 12, md: 7 }}>
                            <Typography variant="h5" component="h3" sx={{ fontWeight: 800, color: '#132c4b', mb: 4 }}>
                                {t('cto_name')}
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1e293b', mb: 3, lineHeight: 1.8 }}>
                                {t('cto_bio_1')}
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1e293b', mb: 3, lineHeight: 1.8 }}>
                                {t('cto_bio_2')}
                            </Typography>
                            <Typography variant="body1" sx={{ color: '#1e293b', lineHeight: 1.8 }}>
                                {t('cto_bio_3')}
                                {' '}
                                <Box component="a" href="https://www.facebook.com/cambodia.jacpage" target="_blank" rel="noopener noreferrer" sx={{ color: '#0ea5e9' }}>JAC</Box>
                                {' '}
                                <Box component="a" href="https://mptc.gov.kh/en/" target="_blank" rel="noopener noreferrer" sx={{ color: '#0ea5e9' }}>MPTC</Box>
                            </Typography>
                        </Grid>
                        <Grid size={{ xs: 12, md: 5 }}>
                            <Box sx={{
                                position: 'relative',
                                width: '100%',
                                aspectRatio: '1/1',
                                overflow: 'hidden',
                                borderRadius: 2
                            }}>
                                <Image
                                    src="/images/board-1.jpg"
                                    alt={t('cto_alt')}
                                    fill
                                    style={{ objectFit: 'cover' }}
                                />
                            </Box>
                        </Grid>
                    </Grid>

                </Stack>
            </Box>
        </Box>
    );
}